import { PageRef } from 'providers/page-ref';
import { NutrientTargets } from '@cf-shared/data-model/food';

export enum MealSuggestionsMode {
  Add = 'add',
  Replace = 'replace'
}

export type MealSuggestionsPageParams = {
  title: string;
  mode?: MealSuggestionsMode;
  returnCallback?: string;
  local?: {
    targets: NutrientTargets;
    /**
     * What a suggested meal should contain, with this meal's own food NOT counted against it.
     *
     * Named for what it is used for rather than where it came from: it used to be handed the
     * stored `meal.planningTargets`, which answers a different question (#5297). Callers build
     * it with `mealTargetsAsIfEmpty`, whose doc comment explains the difference.
     */
    tuningTargets: NutrientTargets;
    returnContext?: unknown;
  };
};

export const IMealSuggestionsPage: PageRef<MealSuggestionsPageParams, void> = {
  pageName: 'MealSuggestionsPage',
} as PageRef<MealSuggestionsPageParams, void>;
